import React from 'react';
import PropTypes from 'prop-types';

import { Nav, NavItem } from 'react-bootstrap';

import { tabs } from './config';


export default function PipelineSettingsTabs({ activeTab, setActiveTab }) {
  return (
    <Nav
      activeKey={activeTab}
      bsStyle="pills"
      className="muted"
      onSelect={setActiveTab}
    >
      {tabs.map(option => (
        <NavItem eventKey={option.value} key={option.value}>
          {option.label}
        </NavItem>
      ))}
    </Nav>
  );
}

PipelineSettingsTabs.propTypes = {
  activeTab: PropTypes.oneOf(tabs.map(option => option.value)).isRequired,
  setActiveTab: PropTypes.func.isRequired,
};
